export enum MaintenanceStatus {
  UP = 'UP',
  MAINTENANCE = 'MAINTENANCE'
}

export enum LearningFeatureOrigin {
  BOOK = 'BOOK',
  CATALOGUE = 'CATALOGUE',
  USER = 'USER'
}

export enum ActivityContentType {
  VOCABULARY = 'VOCABULARY',
  GRAMMAR = 'GRAMMAR',
  TRANSLATION = 'TRANSLATION',
  CONVERSATION = 'CONVERSATION',
  WRITING = 'WRITING',
  LISTENING = 'LISTENING',
  SPELLING = 'SPELLING'
}

export enum EnabledActivityType {
  FLASHCARDS = 'FLASHCARDS',
  PEXESO = 'PEXESO',
  QUIZ = 'QUIZ',
  FLIPCARDS = 'FLIPCARDS',
  WHEEL = 'WHEEL',
  HUNTWORDS = 'HUNTWORDS',
  PICSMATCH = 'PICSMATCH',
  MILLIONAIRE = 'MILLIONAIRE',
  WORD_AHOY = 'WORD_AHOY',
  WILD_WEST = 'WILD_WEST',
  WORD_LADDERS = 'WORD_LADDERS',
  SPELL_WIZARD = 'SPELL_WIZARD',
  TEXT_COMPREHENSION = 'TEXT_COMPREHENSION',
  WORKSHEETS_MATCH_ELEMENTS = 'WORKSHEETS_MATCH_ELEMENTS',
  WORKSHEETS_ONE_TO_MANY = 'WORKSHEETS_ONE_TO_MANY',
  WORKSHEETS_PUZZLE = 'WORKSHEETS_PUZZLE',
  PREPOSITIONS = 'PREPOSITIONS'
}
